import { CALL_API } from '../middleware/ApiMiddleware';

export const S3_SIGNED_URL_REQUEST = 'S3_SIGNED_URL_REQUEST';
export const S3_SIGNED_URL_SUCCESS = 'S3_SIGNED_URL_SUCCESS';
export const S3_SIGNED_URL_FAILURE = 'S3_SIGNED_URL_FAILURE';

export const S3_CRM_SIGNED_URL_REQUEST = 'S3_CRM_SIGNED_URL_REQUEST';
export const S3_CRM_SIGNED_URL_SUCCESS = 'S3_CRM_SIGNED_URL_SUCCESS';
export const S3_CRM_SIGNED_URL_FAILURE = 'S3_CRM_SIGNED_URL_FAILURE';

export const getSignedURL = (agencyId: number, operation: S3Operation, filename: string) => ({
  [CALL_API]: {
    endpoint: `agencies/${agencyId}/s3/signed-url`,
    method: 'get',
    authenticated: true,
    params: {
      operation,
      filename,
    },
    types: [S3_SIGNED_URL_REQUEST, S3_SIGNED_URL_SUCCESS, S3_SIGNED_URL_FAILURE],
  },
});

export const getPresignedURL = (fileUrl: string, expireIn?: number, bucket?: string) => ({
  [CALL_API]: {
    endpoint: `agencies/s3/presigned-url`,
    method: 'get',
    authenticated: true,
    params: {
      fileUrl,
      expireIn,
      bucket,
    },
    types: [S3_SIGNED_URL_REQUEST, S3_SIGNED_URL_SUCCESS, S3_SIGNED_URL_FAILURE],
  },
});

export const getCRMSignedURL = (crmToken: string, operation: S3Operation, filename: string) => ({
  [CALL_API]: {
    endpoint: `crm/${crmToken}/s3/signed-url`,
    method: 'get',
    authenticated: false,
    params: {
      operation,
      filename,
    },
    types: [S3_CRM_SIGNED_URL_REQUEST, S3_CRM_SIGNED_URL_SUCCESS, S3_CRM_SIGNED_URL_FAILURE],
  },
});
